import { EditLocationsRequest } from './edit-locations-request';

export interface EditLocationCalculateETARequest {
  planId?: string;
  jobIds: string[];
  locations: EditLocationsRequest[];
  connectionId: string;
  isSingleLocation: boolean;
}
